// extracted by mini-css-extract-plugin
export var carouselArrowLeft = "carousel-transformer-module--carousel-arrow-left--89e52";
export var carouselArrowRight = "carousel-transformer-module--carousel-arrow-right--f177e";
export var carouselImage = "carousel-transformer-module--carousel-image--2bb2b";
export var carouselImageFit = "carousel-transformer-module--carousel-image-fit--0344b";
export var carouselTransformer = "carousel-transformer-module--carousel-transformer--5b665";
export var modalButton = "carousel-transformer-module--modal-button--a97b8";
export var modalImage = "carousel-transformer-module--modal-image--9afef";
export var pauseButton = "carousel-transformer-module--pause-button--75b86";